export default class QuizEnded {
  render() {
    const row = document.createElement("div");
    row.className = "ws-bot-row ws-quiz-ended-row";

    const spacer = document.createElement("span");
    spacer.className = "ws-avatar ws-bot-avatar ws-quiz-avatar-spacer";
    spacer.setAttribute("aria-hidden", "true");

    const badge = document.createElement("div");
    badge.className = "ws-quiz-ended-button";
    badge.textContent = "Quiz Ended";

    row.appendChild(spacer);
    row.appendChild(badge);
    return row;
  }
}
